import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header_menu_edit_template } from "../components/templates/header_menu_edit_template";
import { header } from "./header";

declare var ko: any;
declare var page: any;

export class header_menu_edit extends vnModule_knockoutJS{

    protected headerMenu: header_menu_edit_template;
    protected XHRHdl: XMLHttpRequestHandler;


    protected getModuleName(): string {

        return "header_menu_edit";
    }
    buildContent(): Array<Element> {
        this.headerMenu = new header_menu_edit_template("headerMenu", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Header Menu");

        return [this.headerMenu.build()];

    }

    public fillPage() : void{
        this.getFormData();
    }
    
    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected getFormData(){

        let id: number;
        this.loadingIn(this.headerMenu.builtTemplate);
        
        if( (id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.viewModel["headerMenu"].id(id);
        }

        let idBrand = this.getBrandId();
        if(id){
            let url: string = '/api/brand/' + idBrand + "/website_header_menu/get/"+id+"/";
            let params: Array<Array<string>> = [];
    
            this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
    
            this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
            this.XHRHdl.execute();
        }else{
            this.loadingOut(this.headerMenu.builtTemplate);
        }
    }

    protected onGetFormDataReturn(req, obj) {
        
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.headerMenu.setMenu(responseParsed[0]);

            });
            obj.loadingOut(obj.headerMenu.builtTemplate);
        }

    }

    public getTagTypesSuggestion(keyword, idElement) {

        if(this.XHRHdl){
            
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/search/tag/type/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {


                let response = JSON.parse(req.request.response);

                if (response.data.tagTypes) {

                    response.data.tagTypes.forEach(tagType => {
                        tagType.name += ` ${tagType.formattedDataset}`;
                    })
                    // obj.editForm.setTagTypeFilter(response.data.idElement, response.data.tagTypes);
                    obj.headerMenu.tagTypeFilter.setOptions(response.data.tagTypes);
                }

            });
        }
    }
    private getContentTypeSuggestion(keyword, idElement) {

        if(this.XHRHdl){
            
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/search/content_types/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetContentTypeSuggestionReturn;
        this.XHRHdl.execute(); 
    }

    protected onGetContentTypeSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                
                let response = JSON.parse(req.request.response);

                if(response){
                    obj.headerMenu.contentTypeFilter.setOptions(response);
                }
            })
        }
    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "filterAutocompleteTagType_template" )
        {

            let filterTypes = this.headerMenu.tagTypeFilter.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.headerMenu.tagTypeFilter.setOptions([]);

            }
        }
        else if (idElement == "filterAutocompleteContentType_template"){
            let contentTypeFilter = this.headerMenu.contentTypeFilter.getTemplateViewModel();
            if(contentTypeFilter.addNewSelected()){
                this.headerMenu.contentTypeFilter.setOptions([]);
            }
        }
    }

    protected getSuggestions(keyword, idSourceElement) {

        if(idSourceElement == "filterAutocompleteContentType_template"){
            this.getContentTypeSuggestion(keyword, idSourceElement);
        }else{

            this.getTagTypesSuggestion(keyword, idSourceElement); 
        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocompleteTagType_template") {
            let tagType = this.headerMenu.tagTypeFilter.getTemplateViewModel().optionObj();
            if (tagType) {
                let tagTypeArray = this.headerMenu.getTemplateViewModel().tagTypes();
                //let currentTagTypes = this.headerMenu.getTemplateViewModel().oldTagTypes().concat(this.headerMenu.getTemplateViewModel().oldTagTypes());
                let addTagType = true;
                for(let i =0; i<tagTypeArray.length; i++){
                    //tagTypeArray Items are all observables 
                    if(tagTypeArray[i].id() == tagType.id){
                        addTagType = false;
                        break;
                    }
                }
                if(addTagType){
                    tagTypeArray.push(tagType);                    
                    this.headerMenu.setTagTypes(tagTypeArray);
                }
                this.headerMenu.tagTypeFilter.clearSelectedOption();
            }
        }
        if (idElement == "filterAutocompleteContentType_template") {
            let contentType = this.headerMenu.contentTypeFilter.getTemplateViewModel().optionObj();
            if (contentType) {
                let contentTypeArray = this.headerMenu.getTemplateViewModel().contentTypes();
                //let currentContentTypes = this.headerMenu.getTemplateViewModel().oldContentTypes().concat(this.headerMenu.getTemplateViewModel().oldContentTypes());
                let addContentType = true;
                for(let i =0; i<contentTypeArray.length; i++){
                    if(contentTypeArray[i].id() == contentType.id){
                        addContentType = false;
                        break;
                    }
                }
                if(addContentType){
                    contentTypeArray.push(contentType);
                    this.headerMenu.setContentTypes(contentTypeArray);
                    //this.headerMenu.getTemplateViewModel().contentTypes(contentTypeArray);
                }
                this.headerMenu.contentTypeFilter.clearSelectedOption();
            }
        }
    }

    public saveMenu(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.headerMenu.builtTemplate);
        let subViewModel = {
            id: this.headerMenu.getTemplateViewModel().id(),
            name: this.headerMenu.getTemplateViewModel().name(),
            tagTypes: this.headerMenu.getTemplateViewModel().tagTypes(),
            contentTypes: this.headerMenu.getTemplateViewModel().contentTypes(),
        }; 
        ///brand/{idBrand}/website_header_menu/save_menu/
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().getApp().params.idBrand + '/website_header_menu/save_menu/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onGetHeaderMenuSaveReturn;
        this.XHRHdl.execute();
    }
    
    private onGetHeaderMenuSaveReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                if (response) {
                    let url: string = '/brand/' + obj.getVnAppZone().getApp().params.idBrand + '/config/header-menu/';
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Header Menu saved successfully!");
                    page.redirect(url);
                }
            });
            obj.loadingOut(obj.headerMenu.builtTemplate);
        }
    }

    public cancelMenu(){
        let url: string = '/brand/' + this.getVnAppZone().getApp().params.idBrand + '/config/header-menu/';
        page.redirect(url);
    }
}



// WEBPACK FOOTER //
// ./js/modules/header_menu_edit.ts